export const
    NEWS_PENDING = 'news_pending',
    NEWS_FAILED = 'news_failed',
    NEWS_DOWNLOADED = 'news_downloaded',
    NEWS_RESET = 'news_reset',
    ONE_NEWS_RESET = 'one_news_reset',
    ONE_NEWS_FOCUS = 'one_news_focus',
    ONE_NEWS_DOWNLOADED = 'one_news_downloaded',
    ONE_NEWS_FAILED = 'one_news_failed',
    ONE_NEWS_DELETING = 'one_news_deleting',
    ONE_NEWS_DELETED = 'one_news_deleted',
    ONE_NEWS_EDITING = 'one_news_editing',
    ONE_NEWS_POSTING = 'one_news_posting',
    ONE_NEWS_MEDIA_FOCUS = 'one_news_media_focus',
    ONE_NEWS_MEDIA_UPLOADING = 'one_news_media_posting',
    ONE_NEWS_MEDIA_FAILED = 'one_news_media_failed',
    ONE_NEWS_MEDIA_UPLOADED = 'one_news_media_uploaded',
    ONE_NEWS_MEDIA_DELETING = 'one_news_media_deleting',
    ONE_NEWS_MEDIA_DELETED = 'one_news_media_deleted';



// WEBPACK FOOTER //
// src/store/news/types.js